module.exports = __webpack_public_path__ + "img/cardinal_logo_black.0fee37ef.png";